module.exports = __webpack_public_path__ + "img/two.ad99733e.png";